import { useCallback, useMemo, useState } from "react";

import * as ModelConverter from "@/components/features/_model/converter";

import * as Factory from "./factory";
import * as FormModelType from "./type";
import * as ValidationSchema from "./validation-schema";

export const useInvoiceSystemSettingsFormModel = (
	initInputModel: FormModelType.InvoiceSystemSettingsFormModel["InputModel"],
) => {
	const defaultInputModel = useMemo(
		() => Factory.Default.invoiceSystemSettingsInputModelFactory(initInputModel.id, initInputModel.hotelID),
		[initInputModel.id, initInputModel.hotelID],
	);

	// InputModel の初期化
	const [currentInputModel, setCurrentInputModel] =
		useState<FormModelType.InvoiceSystemSettingsFormModel["InputModel"]>(initInputModel);

	// ViewModel の初期化
	const [viewModel, setViewModel] = useState<FormModelType.InvoiceSystemSettingsFormModel["ViewModel"]>(
		ModelConverter.inputModelToViewModelConverter<
			FormModelType.InvoiceSystemSettingsFormModel["InputModel"],
			FormModelType.ExcludeKeys,
			FormModelType.InvoiceSystemSettingsFormModel["QueryData"],
			ValidationSchema.InvoiceSystemSettingsInputZodSchemaType
		>({
			defaultInput: defaultInputModel,
			initInput: initInputModel,
			currentInput: initInputModel,
			excludeKeys: FormModelType.excludeKeys,
			zodSchema: ValidationSchema.InvoiceSystemSettingsInputZodSchema,
		}),
	);

	// ViewModel の更新
	const onSetViewModel = useCallback(
		(_viewModel: FormModelType.InvoiceSystemSettingsFormModel["ViewModel"]) => {
			const convertedInputModel = ModelConverter.viewModelToInputModelConverter(_viewModel);
			const convertedViewModel = ModelConverter.inputModelToViewModelConverter<
				FormModelType.InvoiceSystemSettingsFormModel["InputModel"],
				FormModelType.ExcludeKeys,
				FormModelType.InvoiceSystemSettingsFormModel["QueryData"],
				ValidationSchema.InvoiceSystemSettingsInputZodSchemaType
			>({
				defaultInput: defaultInputModel,
				initInput: initInputModel,
				currentInput: convertedInputModel,
				excludeKeys: FormModelType.excludeKeys,
				zodSchema: ValidationSchema.InvoiceSystemSettingsInputZodSchema,
			});
			// state の更新
			setCurrentInputModel(convertedInputModel);
			setViewModel(convertedViewModel);
		},
		[defaultInputModel, initInputModel],
	);

	const onResetViewModel = useCallback(() => {
		setViewModel({
			...viewModel,
			isDirty: false,
		});
	}, [viewModel]);

	return {
		inputModel: currentInputModel,
		viewModel,
		onSetViewModel,
		onResetViewModel,
	};
};
